import templateSelection from '../../../../Template/config/components/selection'
import setBuilder from './SetBuilder'
import metadataSlice from './MetadataSlice'
import search from './Search'

export default {
    ...templateSelection,
    setBuilder,
    metadataSlice,
    search
}


// WEBPACK FOOTER //
// ./src/app/configuration/Optimum/config/components/selection/index.js